import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './StandsPage.scss'
import StandComponent from "../../Components/StandComponent/StandComponent";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {DoorModel} from "../../Models/DoorModel";
import {PdvModel} from "../../Models/PdvModel";
import useHttpClient from "../../hooks/http/useHttpClient";
import {setDoor, setPanier, setTimeCreationPanier} from "../../store/actions";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../../Components/Loader/Loader";
import Error from "../../Components/Error/Error";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useModal} from "../../hooks/useModal";
import {useGetEvent} from "../../hooks/useGetEvent";
import {useError} from "../../hooks/useError";
import {useTranslation} from "react-i18next";

const StandsPage: React.FC = ({}) => {
    const {t} = useTranslation(['stands', 'common'])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {getPdvs} = useHttpClient()
    const [searchParams,] = useSearchParams();
    const doorId = searchParams.get("doorId")

    const door = useSelector<StateModel, DoorModel | undefined>(state => state.door)
    const [stands, setStands] = useState<PdvModel[]>([])

    const loader = useLoader()
    const showError = useModal()
    const eventError = useError()
    const apiError = useError()
    const getEvent = useGetEvent(() => {
        loader.hide()
        eventError.open("")
    }, () => {
        loader.hide()
        apiError.open("")
    })

    useEffect(() => {
        dispatch(setPanier(undefined))
        dispatch(setTimeCreationPanier(undefined))
        loader.show()
        getEvent(
            searchParams.get("stadium") || undefined,
            (doors: DoorModel[]) => {
                dispatch(setDoor(doors.find((d: DoorModel) => d.id.toString() === doorId)))
                if (door) {
                    void getPdvs(door.id).then(r => {
                        setStands(r)
                        loader.hide()
                        if (r.length === 0) {
                            showError.open()
                        }
                    }).catch(() => apiError.open(""))
                        .finally(loader.hide)
                } else {
                    showError.open()
                }
            }
        )
    }, [doorId])


    const handleClick = (standId: number) => {
        navigate(`/menu?stadium=${searchParams.get("stadium")}&pdvId=${standId}`)
    }


    return (
        <BasePage showBack showHistorique showPanier>
            <div className="standsPage">
                {stands.map((stand, index) => (
                    <StandComponent key={index} stand={stand} porte={door?.name || "0"}
                                    handleClick={() => handleClick(stand.id)}/>
                ))}
            </div>
            <Error
                show={showError.visible}
                close={() => navigate(`/choixporte?stadium=${searchParams.get("stadium")}`)}
                title={t('stands:errors.noStandTitle')}
                subTitle={t('stands:errors.noStandSubtitle')}
            />
            <Loader visible={loader.visible}/>
            <Error show={eventError.visible} title={t('common:errors.noEvent.title')}
                   subTitle={t('common:errors.noEvent.subtitle')}/>
            <Error show={apiError.visible} title={t('common:errors.serviceUnavailable.title')}
                   subTitle={t('common:errors.serviceUnavailable.subtitle')}/>
        </BasePage>
    )
}

export default StandsPage;
